import RestService from "./RestService";


export default class SupportService extends RestService {
    constructor() {
        super('/api/topgun');
    }
}
